import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import * as actions from 'redux/actions'
import { UserData } from 'models/Auth'
import { getSlotRestriction } from 'services/reservation/getSlotRestriction'

export enum Status {
  BLOCKED = 'BLOCKED',
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

interface Slot {
  slots: {
    removedSuccess: boolean
    errorMessage: string
  }
}

interface UseRemoveSingleAvailability {
  handleRemoveSlot: () => void
  errorMessage: string
  removedSuccess: boolean
  status: Status
}


export const useRemoveSingleAvailability = ({ slotId }: { slotId: number }): UseRemoveSingleAvailability => {
  const { errorMessage, removedSuccess } = useSelector((state: Slot) => state.slots)
  const userData = useSelector((state: UserData) => state.auth.userData)
  const dispatch = useDispatch()

  const [status, setStatus] = useState<Status>(Status.IDLE) 

  useEffect(() => {
    if (removedSuccess) {
      return setStatus(Status.SUCCESS)
    }
  }, [status, removedSuccess])

  useEffect(() => {
    if (errorMessage) {
      return setStatus(Status.ERROR)
    }
  }, [status, errorMessage])

  const handleRemoveSlot = async() => {
    try {
      setStatus(Status.LOADING)
      const response = await getSlotRestriction(userData.username, slotId)
      
      if (response.data?.restrictions.length > 0) {
        return setStatus(Status.BLOCKED)
      }

    } catch (error) {
      if (error?.response?.status) {
        dispatch(actions.removeSlot(userData.username, slotId))
      }
    } 
  }

  return {
    handleRemoveSlot,
    errorMessage,
    removedSuccess,
    status
  }
}